<template>
<div class="animated fadeIn mt-5" v-if="dataLoaded">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>
          <modal-select modal="dsr-modal" v-validate="'required'" name="dsr_id" :readonly="false" :item-id="item.dsr_id" :item-name="item.dsr?item.dsr.data.name:''" v-on:select-item="selectDsr"  :state="validateState('dsr_id')" placeholder="DSR" label="DSR" ></modal-select>
          <modal-select modal="dsr-modal" v-validate="'required'" name="leader_id" :readonly="false" :item-id="item.leader_id" :item-name="item.leader?item.leader.data.name:''" v-on:select-item="selectLeader"  :state="validateState('leader_id')" placeholder="Leader" label="Leader" ></modal-select>


          <b-form-row>
            <b-col md="4">
              <b-form-group description="(AAAA-mm-dd)" >
                <input type="text" v-model="item.date_start" v-mask="'####-##-##'" class="form-control" placeholder="Data de ínicio" />
              </b-form-group>

            </b-col>
            <b-col md="4">
              <b-form-group description="(AAAA-mm-dd)" >
                <input type="text" v-model="item.date_end" v-mask="'####-##-##'" class="form-control" placeholder="Data de fim" />
              </b-form-group>
            </b-col>

          </b-form-row>


          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'teams.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>


      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Debug </strong>
          </div>

        </b-card>
      </b-col>
      <!--/.col-->
    </div>
  </form>

</div>
</template>

<script>

import Zones from '@/views/dealers/zones/modal.vue'
export default {
  name: 'BestofDsrObjectiveEdit',
  props: ['id'],
  components: {  Zones },
  data() {
    return {
      dataLoaded: false,
      modalType: '',
      showModal: false,
      item: {
        dsr_id: null,
        dsr: { data: {} },
        leader_id: null,
        leader: { data: {} },
        date_start: '',
        date_end: null
      }
    }
  },
  methods: {
    selectDsr(e) {
      this.item.dsr_id = e.item.id
      this.item.dsr.data = e.item
    },
    selectLeader(e) {
      this.item.leader_id = e.item.id
      this.item.leader.data = e.item
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('teams' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'teams.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('teams', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'teams.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('teams' + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.dataLoaded = true
        })
        .catch(response => {
          this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'teams.index'
          })
        })
    } else {
      this.dataLoaded =true
    }
  }
}
</script>
